// src/components/AppShell.tsx
'use client';

import { usePathname } from 'next/navigation';
import Sidebar from '@/components/Sidebar';
import SidebarResizeHandle from '@/components/SidebarResizeHandle';

export default function AppShell({
  children,
  hideSidebar = false,
}: {
  children: React.ReactNode;
  hideSidebar?: boolean;
}) {
  const pathname = usePathname() || '/';

  const isAuthPage =
    pathname.startsWith('/sign-in') ||
    pathname.startsWith('/sign-up') ||
    pathname.startsWith('/sign-out') ||
    pathname.includes('sso-callback');

  return (
    <div className="flex min-h-[100dvh]">
      <aside
        className={`ktr-sidebar border-r ${
          hideSidebar ? 'hidden' : 'hidden md:flex md:flex-col'
        }`}
      >
        <Sidebar />
      </aside>
      <main className="ktr-main flex-1 min-w-0 overflow-x-hidden">
        <div className="md:p-4">{children}</div>
      </main>
    </div>
  );
}
